<template>
  <div class='login-bg'>
    <div class="wrapper login">
			<div class="row">
				<div class="col text-center">
					<div class="logo-brand">Pesquisa<span> de Clima</span></div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<form action="" @submit.prevent="login">
            <div class="row">
              <div class="col-8 offset-2">
                <div class="form-group">
                  <label>E-mail</label>
                  <input type="tel" class="form-control" v-model="user.email">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-8 offset-2">
                <div class="form-group">
                  <label>Senha</label>
                  <input type="password" class="form-control" v-model="user.password">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-8 offset-2">
                <button type="submit" class="btn btn-tasks btn-block clickable">Entrar</button>
              </div>
            </div>

					</form>
				</div>
			</div>

			<footer class="white">
				<div>Desenvolvido por <img src="../assets/images/logo-innovare.png" alt="" /></div>
			</footer>
		</div>
  </div>
</template>

<script>
export default {
   data() {
    return {
      user: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          email: self.user.email,
          password: self.user.password,
        })
        .then(response => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push('/');
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  }
};
</script>

<style scoped>
body {
  font-family: "Roboto", sans-serif;
}
form .form-input {
  width: 90% !important;
  font-size: 15px !important;
  padding: 10px !important;
  border: 1px solid #c0c0c0;
}
form .form-label {
  width: 90% !important;
  display: block;
  text-align: left;
  font-size: 16px !important;
  margin-left: auto;
  margin-right: auto;
}
form .form-button {
  width: 90%;
  padding: 10px;
  font-size: 18px;
  border-radius: 30px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #f0f0f0;
  background: #1197d6 !important;
  color: white;
}

#myModal {
  text-align: left;
}

@media (max-width: 768px) {
  .ibox {
    margin: 0px 0px 0px 0px;
  }
}

form label {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginEmail.vue